// Auto-generated file - do not edit manually
// Generated by scripts/generate-docs.ts
// Maps block types to their icon component references

import type { ComponentType, SVGProps } from 'react'
import {
  Blimp,
  CirclePause,
  Clock,
  FormInput,
  GridOffset,
  Library,
  Play,
  Rocket,
  Table,
  Task,
  Webhook,
} from '@sim/emcn/icons'
import {
  A2AIcon,
  AffinityIcon,
  AgentIcon,
  AgentMailIcon,
  AgentPhoneIcon,
  AgiloftIcon,
  AhrefsIcon,
  AirtableIcon,
  AirweaveIcon,
  AlgoliaIcon,
  AmplitudeIcon,
  ApifyIcon,
  ApiIcon,
  ApolloIcon,
  AppConfigIcon,
  ArxivIcon,
  AsanaIcon,
  AshbyIcon,
  AthenaIcon,
  AttioIcon,
  AzureDataExplorerIcon,
  AzureIcon,
  BitbucketIcon,
  BoxCompanyIcon,
  BrainIcon,
  BrandfetchIcon,
  BrexIcon,
  BrightDataIcon,
  BrowserUseIcon,
  BufferIcon,
  CalComIcon,
  CalendlyIcon,
  CbInsightsIcon,
  ChartBarIcon,
  CirclebackIcon,
  ClaudeIcon,
  ClayIcon,
  ClerkIcon,
  ClickHouseIcon,
  ClickUpIcon,
  CloudFormationIcon,
  CloudflareIcon,
  CloudTrailIcon,
  CloudWatchIcon,
  CodaIcon,
  CodeIcon,
  CodePipelineIcon,
  ConditionalIcon,
  ConfluenceIcon,
  ConnectIcon,
  ContextDevIcon,
  ConvexIcon,
  CredentialIcon,
  CrowdStrikeIcon,
  CrunchbaseIcon,
  CursorIcon,
  DagsterIcon,
  DatabricksIcon,
  DatadogIcon,
  DatagmaIcon,
  DaytonaIcon,
  DevinIcon,
  DiscordIcon,
  DocumentIcon,
  DocuSignIcon,
  DowndetectorIcon,
  DropboxIcon,
  DropcontactIcon,
  DsPyIcon,
  DubIcon,
  DuckDuckGoIcon,
  DynamoDBIcon,
  DynatraceIcon,
  ElasticsearchIcon,
  ElevenLabsIcon,
  EmailBisonIcon,
  EmbeddingsIcon,
  EnrichmentIcon,
  EnrichSoIcon,
  EnrowIcon,
  ExaAIIcon,
  ExtendIcon,
  EyeIcon,
  FathomIcon,
  FindymailIcon,
  FirecrawlIcon,
  FirefliesIcon,
  FlintIcon,
  GammaIcon,
  GithubIcon,
  GitLabIcon,
  GmailIcon,
  GongIcon,
  GoogleAdsIcon,
  GoogleAppsheetIcon,
  GoogleBigQueryIcon,
  GoogleBooksIcon,
  GoogleCalendarIcon,
  GoogleContactsIcon,
  GoogleDocsIcon,
  GoogleDriveIcon,
  GoogleFormsIcon,
  GoogleGroupsIcon,
  GoogleIcon,
  GoogleMapsIcon,
  GoogleMeetIcon,
  GooglePagespeedIcon,
  GoogleSheetsIcon,
  GoogleSlidesIcon,
  GoogleTasksIcon,
  GoogleTranslateIcon,
  GoogleVaultIcon,
  GrafanaIcon,
  GrainIcon,
  GranolaIcon,
  GreenhouseIcon,
  GreptileIcon,
  HarmonicIcon,
  HexIcon,
  HubspotIcon,
  HuggingFaceIcon,
  HumanInTheLoopIcon,
  HunterIOIcon,
  IAMIcon,
  IcypeasIcon,
  IdentityCenterIcon,
  ImageIcon,
  IncidentioIcon,
  InfisicalIcon,
  InstantlyIcon,
  IntercomIcon,
  JinaAIIcon,
  JiraIcon,
  JiraServiceManagementIcon,
  JotformIcon,
  JupyterIcon,
  KalshiIcon,
  KetchIcon,
  LambdaIcon,
  LangsmithIcon,
  LatexIcon,
  LaunchDarklyIcon,
  LeadMagicIcon,
  LemlistIcon,
  LinearIcon,
  LinkedInIcon,
  LinkupIcon,
  LinqIcon,
  LogfireIcon,
  LogRocketIcon,
  LoopsIcon,
  LumaIcon,
  MailchimpIcon,
  MailgunIcon,
  MailServerIcon,
  ManageEngineIcon,
  McpIcon,
  Mem0Icon,
  MicrosoftDataverseIcon,
  MicrosoftExcelIcon,
  MicrosoftOneDriveIcon,
  MicrosoftPlannerIcon,
  MicrosoftSharepointIcon,
  MicrosoftSqlIcon,
  MicrosoftTeamsIcon,
  MicrosoftWordIcon,
  MillionVerifierIcon,
  MintlifyIcon,
  MistralIcon,
  ModalIcon,
  MondayIcon,
  MongoDBIcon,
  MySQLIcon,
  Neo4jIcon,
  NetSuiteIcon,
  NeverBounceIcon,
  NewRelicIcon,
  NoteIcon,
  NotionIcon,
  ObsidianIcon,
  OktaIcon,
  OnePasswordIcon,
  OpenAIIcon,
  OtterIcon,
  OutlookIcon,
  PackageSearchIcon,
  PagerDutyIcon,
  ParallelIcon,
  PeopleDataLabsIcon,
  PerplexityIcon,
  PersonaIcon,
  PiIcon,
  PineconeIcon,
  PipedriveIcon,
  PitchBookIcon,
  PlanetScaleIcon,
  PolymarketIcon,
  PostgresIcon,
  PosthogIcon,
  PowerBIIcon,
  ProfoundIcon,
  ProspeoIcon,
  PulseIcon,
  QdrantIcon,
  QuartrIcon,
  QuickBooksIcon,
  QuiverIcon,
  RabbitmqIcon,
  RailwayIcon,
  RB2BIcon,
  RDSIcon,
  RedditIcon,
  RedisIcon,
  ReductoIcon,
  ResendIcon,
  ResponseIcon,
  RevenueCatIcon,
  RipplingIcon,
  RocketlaneIcon,
  RootlyIcon,
  RssIcon,
  S3Icon,
  SailPointIcon,
  SalesforceIcon,
  SapConcurIcon,
  SapS4HanaIcon,
  SESIcon,
  SearchIcon,
  SecretsManagerIcon,
  SemrushIcon,
  SendblueIcon,
  SendgridIcon,
  SentryIcon,
  SerperIcon,
  ServiceNowIcon,
  SftpIcon,
  ShieldCheckIcon,
  ShopifyIcon,
  SimilarwebIcon,
  SimTriggerIcon,
  SixtyfourIcon,
  SlackIcon,
  SmartleadIcon,
  SmtpIcon,
  SnowflakeIcon,
  SplunkIcon,
  SportmonksIcon,
  SQSIcon,
  SquareIcon,
  SSMIcon,
  SshIcon,
  STSIcon,
  STTIcon,
  StagehandIcon,
  StartIcon,
  StripeIcon,
  SupabaseIcon,
  TailscaleIcon,
  TavilyIcon,
  TelegramIcon,
  TemporalIcon,
  TextractIcon,
  ThriveIcon,
  TikTokIcon,
  TinybirdIcon,
  TinyFishIcon,
  TranslateIcon,
  TrelloIcon,
  TriggerDevIcon,
  TTSIcon,
  TwilioIcon,
  TypeformIcon,
  UpstashIcon,
  UptimeRobotIcon,
  VantaIcon,
  VariableIcon,
  VercelIcon,
  VideoIcon,
  WealthboxIcon,
  WebflowIcon,
  WebhookIcon,
  WhatsAppIcon,
  WikipediaIcon,
  WindchillIcon,
  WizaIcon,
  WordpressIcon,
  WorkdayIcon,
  WorkflowIcon,
  xIcon,
  YouComIcon,
  YouTubeIcon,
  ZendeskIcon,
  ZepIcon,
  ZeroBounceIcon,
  ZohoDeskIcon,
  ZoomIcon,
  ZoomInfoIcon,
} from '@/components/icons'

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

export const blockTypeToIconMap: Record<string, IconComponent> = {
  a2a: A2AIcon,
  affinity: AffinityIcon,
  agent: AgentIcon,
  agentmail: AgentMailIcon,
  agentphone: AgentPhoneIcon,
  agiloft: AgiloftIcon,
  ahrefs: AhrefsIcon,
  airtable: AirtableIcon,
  airweave: AirweaveIcon,
  algolia: AlgoliaIcon,
  amplitude: AmplitudeIcon,
  api: ApiIcon,
  api_trigger: ApiIcon,
  apify: ApifyIcon,
  apollo: ApolloIcon,
  appconfig: AppConfigIcon,
  arxiv: ArxivIcon,
  asana: AsanaIcon,
  ashby: AshbyIcon,
  athena: AthenaIcon,
  attio: AttioIcon,
  azure_data_explorer: AzureDataExplorerIcon,
  azure_devops: AzureIcon,
  bitbucket: BitbucketIcon,
  box: BoxCompanyIcon,
  box_v2: BoxCompanyIcon,
  brandfetch: BrandfetchIcon,
  brex: BrexIcon,
  brightdata: BrightDataIcon,
  browser_use: BrowserUseIcon,
  buffer: BufferIcon,
  calcom: CalComIcon,
  calendly: CalendlyIcon,
  cbinsights: CbInsightsIcon,
  chat_trigger: Task,
  circleback: CirclebackIcon,
  clay: ClayIcon,
  clerk: ClerkIcon,
  clickhouse: ClickHouseIcon,
  clickup: ClickUpIcon,
  cloudflare: CloudflareIcon,
  cloudformation: CloudFormationIcon,
  cloudtrail: CloudTrailIcon,
  cloudwatch: CloudWatchIcon,
  coda: CodaIcon,
  codepipeline: CodePipelineIcon,
  condition: ConditionalIcon,
  confluence: ConfluenceIcon,
  confluence_v2: ConfluenceIcon,
  context_dev: ContextDevIcon,
  convex: ConvexIcon,
  credential: CredentialIcon,
  credential_group: GridOffset,
  crowdstrike: CrowdStrikeIcon,
  crunchbase: CrunchbaseIcon,
  cursor: CursorIcon,
  cursor_v2: CursorIcon,
  dagster: DagsterIcon,
  databricks: DatabricksIcon,
  datadog: DatadogIcon,
  datagma: DatagmaIcon,
  daytona: DaytonaIcon,
  deployments: Rocket,
  devin: DevinIcon,
  discord: DiscordIcon,
  docusign: DocuSignIcon,
  downdetector: DowndetectorIcon,
  dropbox: DropboxIcon,
  dropbox_v2: DropboxIcon,
  dropcontact: DropcontactIcon,
  dspy: DsPyIcon,
  dub: DubIcon,
  dub_v2: DubIcon,
  duckduckgo: DuckDuckGoIcon,
  dynamodb: DynamoDBIcon,
  dynatrace: DynatraceIcon,
  elasticsearch: ElasticsearchIcon,
  elevenlabs: ElevenLabsIcon,
  emailbison: EmailBisonIcon,
  embeddings: EmbeddingsIcon,
  enrich: EnrichSoIcon,
  enrichment: EnrichmentIcon,
  enrow: EnrowIcon,
  evaluator: ChartBarIcon,
  exa: ExaAIIcon,
  extend: ExtendIcon,
  extend_v2: ExtendIcon,
  fathom: FathomIcon,
  file: DocumentIcon,
  file_v2: DocumentIcon,
  file_v3: DocumentIcon,
  file_v4: DocumentIcon,
  file_v5: DocumentIcon,
  findymail: FindymailIcon,
  firecrawl: FirecrawlIcon,
  fireflies: FirefliesIcon,
  fireflies_v2: FirefliesIcon,
  flint: FlintIcon,
  function: CodeIcon,
  gamma: GammaIcon,
  generic: WebhookIcon,
  generic_webhook: Webhook,
  github: GithubIcon,
  github_v2: GithubIcon,
  gitlab: GitLabIcon,
  gmail: GmailIcon,
  gmail_v2: GmailIcon,
  gong: GongIcon,
  google_ads: GoogleAdsIcon,
  google_appsheet: GoogleAppsheetIcon,
  google_bigquery: GoogleBigQueryIcon,
  google_books: GoogleBooksIcon,
  google_calendar: GoogleCalendarIcon,
  google_calendar_v2: GoogleCalendarIcon,
  google_contacts: GoogleContactsIcon,
  google_docs: GoogleDocsIcon,
  google_drive: GoogleDriveIcon,
  google_forms: GoogleFormsIcon,
  google_groups: GoogleGroupsIcon,
  google_maps: GoogleMapsIcon,
  google_meet: GoogleMeetIcon,
  google_pagespeed: GooglePagespeedIcon,
  google_search: GoogleIcon,
  google_sheets: GoogleSheetsIcon,
  google_sheets_v2: GoogleSheetsIcon,
  google_slides: GoogleSlidesIcon,
  google_slides_v2: GoogleSlidesIcon,
  google_tasks: GoogleTasksIcon,
  google_translate: GoogleTranslateIcon,
  google_vault: GoogleVaultIcon,
  'google-calendar': GoogleCalendarIcon,
  'google-drive': GoogleDriveIcon,
  'google-sheets': GoogleSheetsIcon,
  grafana: GrafanaIcon,
  grain: GrainIcon,
  grain_v2: GrainIcon,
  granola: GranolaIcon,
  greenhouse: GreenhouseIcon,
  greptile: GreptileIcon,
  guardrails: ShieldCheckIcon,
  harmonic: HarmonicIcon,
  hex: HexIcon,
  hubspot: HubspotIcon,
  huggingface: HuggingFaceIcon,
  human_in_the_loop: HumanInTheLoopIcon,
  human_in_the_loop_v2: HumanInTheLoopIcon,
  hunter: HunterIOIcon,
  iam: IAMIcon,
  icypeas: IcypeasIcon,
  identity_center: IdentityCenterIcon,
  image_generator: ImageIcon,
  image_generator_v2: ImageIcon,
  imap: MailServerIcon,
  incidentio: IncidentioIcon,
  infisical: InfisicalIcon,
  input_trigger: FormInput,
  instantly: InstantlyIcon,
  intercom: IntercomIcon,
  intercom_v2: IntercomIcon,
  jina: JinaAIIcon,
  jira: JiraIcon,
  jira_service_management: JiraServiceManagementIcon,
  jotform: JotformIcon,
  jsm: JiraServiceManagementIcon,
  jupyter: JupyterIcon,
  jupyter_v2: JupyterIcon,
  kalshi: KalshiIcon,
  kalshi_v2: KalshiIcon,
  ketch: KetchIcon,
  knowledge: PackageSearchIcon,
  lambda: LambdaIcon,
  langsmith: LangsmithIcon,
  latex: LatexIcon,
  launchdarkly: LaunchDarklyIcon,
  leadmagic: LeadMagicIcon,
  lemlist: LemlistIcon,
  linear: LinearIcon,
  linear_v2: LinearIcon,
  linkedin: LinkedInIcon,
  linkup: LinkupIcon,
  linq: LinqIcon,
  logfire: LogfireIcon,
  logrocket: LogRocketIcon,
  logs: Library,
  logs_v2: Library,
  loops: LoopsIcon,
  luma: LumaIcon,
  mailchimp: MailchimpIcon,
  mailgun: MailgunIcon,
  managed_agent: ClaudeIcon,
  manageengine_sdp: ManageEngineIcon,
  manual_trigger: Play,
  mcp: McpIcon,
  mem0: Mem0Icon,
  memory: BrainIcon,
  microsoft_ad: AzureIcon,
  microsoft_dataverse: MicrosoftDataverseIcon,
  microsoft_dataverse_v2: MicrosoftDataverseIcon,
  microsoft_dynamics_365: MicrosoftDataverseIcon,
  microsoft_excel: MicrosoftExcelIcon,
  microsoft_excel_v2: MicrosoftExcelIcon,
  microsoft_planner: MicrosoftPlannerIcon,
  microsoft_teams: MicrosoftTeamsIcon,
  microsoft_word: MicrosoftWordIcon,
  'microsoft-teams': MicrosoftTeamsIcon,
  millionverifier: MillionVerifierIcon,
  mintlify: MintlifyIcon,
  mistral_parse: MistralIcon,
  mistral_parse_v2: MistralIcon,
  mistral_parse_v3: MistralIcon,
  modal: ModalIcon,
  monday: MondayIcon,
  mongodb: MongoDBIcon,
  mothership: Blimp,
  mssql: MicrosoftSqlIcon,
  mysql: MySQLIcon,
  neo4j: Neo4jIcon,
  netsuite: NetSuiteIcon,
  neverbounce: NeverBounceIcon,
  new_relic: NewRelicIcon,
  note: NoteIcon,
  notion: NotionIcon,
  notion_v2: NotionIcon,
  obsidian: ObsidianIcon,
  okta: OktaIcon,
  onedrive: MicrosoftOneDriveIcon,
  onepassword: OnePasswordIcon,
  openai: OpenAIIcon,
  otter: OtterIcon,
  outlook: OutlookIcon,
  pagerduty: PagerDutyIcon,
  parallel_ai: ParallelIcon,
  peopledatalabs: PeopleDataLabsIcon,
  perplexity: PerplexityIcon,
  persona: PersonaIcon,
  pi: PiIcon,
  pinecone: PineconeIcon,
  pipedrive: PipedriveIcon,
  pitchbook: PitchBookIcon,
  planetscale: PlanetScaleIcon,
  polymarket: PolymarketIcon,
  postgresql: PostgresIcon,
  posthog: PosthogIcon,
  powerbi: PowerBIIcon,
  profound: ProfoundIcon,
  prospeo: ProspeoIcon,
  pulse: PulseIcon,
  pulse_v2: PulseIcon,
  qdrant: QdrantIcon,
  quartr: QuartrIcon,
  quickbooks: QuickBooksIcon,
  quiver: QuiverIcon,
  quiver_v2: QuiverIcon,
  rabbitmq: RabbitmqIcon,
  railway: RailwayIcon,
  rb2b: RB2BIcon,
  rds: RDSIcon,
  reddit: RedditIcon,
  redis: RedisIcon,
  reducto: ReductoIcon,
  reducto_v2: ReductoIcon,
  resend: ResendIcon,
  response: ResponseIcon,
  revenuecat: RevenueCatIcon,
  rippling: RipplingIcon,
  rocketlane: RocketlaneIcon,
  rootly: RootlyIcon,
  router: ConnectIcon,
  router_v2: ConnectIcon,
  rss: RssIcon,
  s3: S3Icon,
  sailpoint: SailPointIcon,
  salesforce: SalesforceIcon,
  sap_concur: SapConcurIcon,
  sap_s4hana: SapS4HanaIcon,
  schedule: Clock,
  search: SearchIcon,
  secrets_manager: SecretsManagerIcon,
  semrush: SemrushIcon,
  sendblue: SendblueIcon,
  sendgrid: SendgridIcon,
  sentry: SentryIcon,
  serper: SerperIcon,
  servicenow: ServiceNowIcon,
  servicenow_v2: ServiceNowIcon,
  ses: SESIcon,
  sftp: SftpIcon,
  sftp_v2: SftpIcon,
  sharepoint: MicrosoftSharepointIcon,
  sharepoint_v2: MicrosoftSharepointIcon,
  shopify: ShopifyIcon,
  sim_workspace_event: SimTriggerIcon,
  similarweb: SimilarwebIcon,
  sixtyfour: SixtyfourIcon,
  slack: SlackIcon,
  slack_app: SlackIcon,
  slack_v2: SlackIcon,
  smartlead: SmartleadIcon,
  smtp: SmtpIcon,
  snowflake: SnowflakeIcon,
  splunk: SplunkIcon,
  sportmonks: SportmonksIcon,
  sqs: SQSIcon,
  square: SquareIcon,
  ssh: SshIcon,
  ssh_v2: SshIcon,
  ssm: SSMIcon,
  stagehand: StagehandIcon,
  start_trigger: StartIcon,
  starter: StartIcon,
  stripe: StripeIcon,
  sts: STSIcon,
  stt: STTIcon,
  stt_v2: STTIcon,
  supabase: SupabaseIcon,
  table: Table,
  table_v2: Table,
  tailscale: TailscaleIcon,
  tavily: TavilyIcon,
  telegram: TelegramIcon,
  temporal: TemporalIcon,
  textract: TextractIcon,
  textract_v2: TextractIcon,
  thinking: BrainIcon,
  thrive: ThriveIcon,
  tiktok: TikTokIcon,
  tinybird: TinybirdIcon,
  tinyfish: TinyFishIcon,
  translate: TranslateIcon,
  trello: TrelloIcon,
  trigger_dev: TriggerDevIcon,
  tts: TTSIcon,
  twilio: TwilioIcon,
  twilio_sms: TwilioIcon,
  twilio_voice: TwilioIcon,
  typeform: TypeformIcon,
  upstash: UpstashIcon,
  uptimerobot: UptimeRobotIcon,
  vanta: VantaIcon,
  variables: VariableIcon,
  vercel: VercelIcon,
  video_generator: VideoIcon,
  video_generator_v2: VideoIcon,
  video_generator_v3: VideoIcon,
  vision: EyeIcon,
  vision_v2: EyeIcon,
  wait: CirclePause,
  wealthbox: WealthboxIcon,
  webflow: WebflowIcon,
  webhook_request: WebhookIcon,
  whatsapp: WhatsAppIcon,
  wikipedia: WikipediaIcon,
  windchill: WindchillIcon,
  wiza: WizaIcon,
  wordpress: WordpressIcon,
  workday: WorkdayIcon,
  workflow: WorkflowIcon,
  workflow_input: WorkflowIcon,
  x: xIcon,
  youcom: YouComIcon,
  youtube: YouTubeIcon,
  zendesk: ZendeskIcon,
  zep: ZepIcon,
  zerobounce: ZeroBounceIcon,
  zoho_desk: ZohoDeskIcon,
  zoom: ZoomIcon,
  zoominfo: ZoomInfoIcon,
}

export const coreBlockTypes = new Set([
  'a2a',
  'agent',
  'api',
  'api_trigger',
  'chat_trigger',
  'condition',
  'credential',
  'credential_group',
  'deployments',
  'enrichment',
  'evaluator',
  'file',
  'file_v2',
  'file_v3',
  'file_v4',
  'file_v5',
  'function',
  'generic_webhook',
  'guardrails',
  'human_in_the_loop',
  'human_in_the_loop_v2',
  'image_generator',
  'image_generator_v2',
  'imap',
  'input_trigger',
  'knowledge',
  'logs',
  'logs_v2',
  'manual_trigger',
  'mcp',
  'memory',
  'mothership',
  'note',
  'pi',
  'response',
  'router',
  'router_v2',
  'rss',
  'schedule',
  'search',
  'sim_workspace_event',
  'start_trigger',
  'starter',
  'stt',
  'stt_v2',
  'table',
  'table_v2',
  'thinking',
  'translate',
  'tts',
  'variables',
  'video_generator',
  'video_generator_v2',
  'video_generator_v3',
  'vision',
  'vision_v2',
  'wait',
  'webhook_request',
  'workflow',
  'workflow_input',
])
